import { combineReducers } from 'redux';

//产品首页
function productInfo(
  state={advPic1:{"name":"","code":"","type":"","createDate":"","picList":[{pictureUrl:""}],key:''},
          advPic2:{"name":"","code":"","type":"","createDate":"","picList":[{pictureUrl:""}],key:''},
          bannerPic:{"name":"","code":"","type":"","createDate":"","picList":[{pictureUrl:""},{pictureUrl:""},{pictureUrl:""},{pictureUrl:""},{pictureUrl:""}],key:''}, 
          featureGroupList:[],fundCommendList:[]}
  , action) {
  switch(action.type) {
    case "PRODUCT_INFO":
      return action.text; 
      break;
    default: 
      return state;
      break;
  }
}

const productReducer = combineReducers({
	productInfo,
});

export default productReducer;


// WEBPACK FOOTER //
// ./src/reducer/productReducer.js